import styled, {createGlobalStyle} from "styled-components";

export const GlobalStyle = createGlobalStyle`
	/* Subtle border that reads on the dark (default) theme */
	:root {
		--border-subtle: rgba(140, 150, 170, 0.14);
	}

	#light {
		/* Subtle border tuned for the light theme */
		--border-subtle: rgba(40, 50, 70, 0.1);
		color: var(--txt-dg);
		#body p {
			color: var(--txt-dg);
			&.form-type {
				color: #fff;
			}
		}
		#light .menu-wrapper {
			background: #fff;
		}
		.search-field {
			background: #fff;
			color: var(--txt-dg);
		}
		.activity-row {
			background: #fff !important;
		}
		.salesforce-wrapper {
			background: transparent !important;
		}
		.company-content.card {
			background: #fff !important;
			box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
		}
		#sidebar .company-card {
			background: #fff !important;
		}
		#sidebar .company-card .title {
			color: var(--txt-dg);
		}
		#sidebar .company-card .created .name {
			color: var(--txt-dg);
		}
		.action-bar .help-btn {
			background: var(--bg-l2);
			color: var(--txt-lg);
		}
		.action-bar .help-btn:hover {
			background: var(--bg-l3);
			color: var(--violet);
		}
		.company-info-table dd {
			color: var(--txt-dg);
		}
		.company-row {
			background: #fff !important;
			.favicon {
				border: 1px solid var(--bg-l1);
				background: var(--bg-l1);
			}
		}
	}
`;


export const CompanyWrapperEl = styled.div`
	display: block;
	position: relative;
	font-size: 1em;

	h1 {
		color: var(--txt-dg);
		font-size: 1.5em;
		padding-bottom: 1em;
	}

	& .body-wrapper {
		padding: 6em 6em 5em 6em !important;
		text-align: center;
		max-width: 1100px;
		margin: 0 auto;
		&.show {
			animation: company-body-show-ani 0.25s ease-in-out 1 forwards;
			-webkit-animation: company-body-show-ani 0.25s ease-in-out 1 forwards;
			-moz-animation: company-body-show-ani 0.25s ease-in-out 1 forwards;
			-o-animation: company-body-show-ani 0.25s ease-in-out 1 forwards;
		}
	}

	@keyframes company-body-show-ani {
		0% {
			opacity: 0;
			top: 70px;
		}
		100% {
			opacity: 1;
			top: 60px;
		}
	}
	
	.search-field {
		background: var(--bg-d0-dash);
		border-radius: 3px;
		&::-webkit-calendar-picker-indicator {
			opacity: 100;
			padding: 1em;
		}
	}
	.sort-wrapper,
	.filter-wrapper {
		color: var(--txt-lg);
		font-size: 12px;
		text-transform: uppercase;
		letter-spacing: 1px;
		margin-bottom: 2em;
		text-align: right;
		select {
			font-size: 12px;
			color: var(--txt-lg);
			text-transform: uppercase;
			letter-spacing: 1px;
			background: none;
			border: none;
		}
		input {
			font-size: 12px;
			color: var(--txt-lg);
			text-transform: uppercase;
			letter-spacing: 1px;
			padding-right: 1em;
			background: none;
			border: none;
			padding: 1em;
		}
		button {
			font-size: 12px;
			color: var(--txt-lg);
			text-transform: uppercase;
			letter-spacing: 1px;
			margin-left: 1em;
			background: none;
			border: none;
		}
	}
	#add-tag {
		font-size: 2em;
	}
	.tag-list {
		flex-direction: column;
		flex-wrap: wrap;
		padding: 0.5em 0;
		min-height: 3em;
		div {
			display: inline-flex;
			background: var(--txt-dg);
			color: #fff;
			padding: 0 0.5em;
			border-radius: 3px;
			margin-left: 0.5em;
		}
	}

	& .company-column {
		display: inline-block;
		vertical-align: top;
		min-height: 100px;
		position: relative;
		width: 50%;
		padding: 2em;
		max-width: 400px;
	}

	& .body-wrapper.two-col .company-column {
		width: 48%;
		max-width: 500px;
	}

	& .company-column.search-wrapper input::placeholder {
		color: var(--txt-lg);
	}

	& .company-column h1 {
		color: var(--txt-lg);
		font-size: 13px;
		margin-bottom: 23px;
		vertical-align: top;
		span {
			font-size: 13px;
		}
		img {
			height: 18px;
			width: 18px;
			margin: -1px 8px 0 0;
			vertical-align: top;
			&.search {
				background-image: var(--icon-search-lg);
			}
			&.history {
				background-image: var(--icon-history-lg);
			}
			&.activity {
				background-image: var(--icon-activity-lg);
			}
			&.legacy {
				background-image: var(--icon-legacy-lg);
			}
		}
	}

	& .company-column .section-prompt {
		color: var(--txt-lg);
		text-align: center;
		font-size: 12px;
		margin-top: 10px;
		padding: 0 40px;
	}

	& .company-row {
		display: block;
		margin-top: 10px;
		background: var(--bg-d2);
		border-radius: 3px;
		border: 1px solid transparent;
		transition: background 0.05s, border 0.05s, top 0.5s, -moz-transform ease-in-out 0.05s;
		position: relative;
		min-height: 60px;

		&:hover {
			cursor: pointer;
			border: 1px solid var(--blue);
		}

		.click-zone {
			position: absolute;
			height: 100%;
			width: 100%;
			z-index: 1;
			a {
				position: absolute;
				top: 0;
				left: 0;
				height: 100%;
				width: 100%;
				color: transparent;
			}
		}

		.favicon-wrapper {
			margin: 10px 0 0 15px;
			display: inline-block;
			vertical-align: top;
			text-align: center;
			.form-type {
				text-transform: uppercase;
				font-size: 10px;
				padding: 5px;
				border-radius: 3px;
				font-weight: 900;
				width: 30px;
				margin-top: 3px;
				&.tt {
					background: var(--darkgreen);
				}
				&.lc {
					background: var(--violet);
				}
				&.pc {
					background: var(--blue);
				}
				&.em {
					background: var(--blue);
				}
				&.nc {
					background: var(--gray);
				}
				&.ce {
					background: var(--red);
				}
			}
		}

		.favicon {
			font-size: 12px;
			padding: 3px;
			border-radius: 3px;
			width: 22px;
			height: 22px;
			border: 1px solid var(--bg-d0);
			background: var(--bg-d0);
		}

		.status-wrapper {
			padding: 0;
			margin: 1px 0 0 0;
			height: 12px;
		}

		.status {
			width: 4px;
			height: 4px;
			border-radius: 2px;
			background: white;
			margin: 3px auto 0 auto;
			display: inline-block;
			vertical-align: top;
			&.active {
				background: var(--green);
			}

			&.paused {
				background: var(--red);
			}
		}

		.form-count {
			display: inline-block;
			vertical-align: top;
			color: var(--txt-lg);
			font-size: 10px;
			margin-left: 3px;
			margin-top: -2px;
			padding: 0;
		}

		.menu-hover-wrapper {
			height: 20px;
			width: 20px;
			position: absolute;
			top: 10px;
			right: 4px;
			border-radius: 3px;
			z-index: 2;
			text-align: right;
			.menu-icon {
				position: absolute;
				top: 0;
				right: 0;
				bottom: 0;
				left: 0;
				margin: auto;
				height: 30px;
				z-index: 10;
				color: var(--txt-lg2);
				font-size: 20px;
			}
			&:hover {
				cursor: pointer;
				background: var(--bg-l1);
				padding: 4px 0;
				width: auto;
				height: auto !important;
				z-index: 100 !important;
			}
			&:hover > .menu-icon {
				display: none;
			}
			.menu-wrapper {
				display: none;
				height: auto;
			}
			.menu-btn {
				font-size: 12px;
				color: var(--txt-d);
				text-align: left;
				margin: 0 4px;
				border-radius: 2px;
				padding: 2px 60px 0 10px;
				&:hover {
					color: white;
				}
				&.edit:hover {
					background: var(--blue);
				}
				&.clone:hover {
					background: var(--lt-green-bg);
				}
				&.delete:hover {
					background: var(--red);
				}
			}
			&:hover > .menu-wrapper {
				display: block;
			}
		}

		.delete-btn:hover > span {
			opacity: 1;
		}

		.text {
			padding: 10px 22px 10px 5px;
			height: auto !important;
			display: inline-block;
			vertical-align: top;
			width: calc(100% - 60px);
			text-align: left;
			margin-left: 5px;
		}

		.title {
			font-size: 13px;

			span {
				color: var(--bg-l1);
				border: 1px solid;
				font-size: 10px;
				padding: 2px 4px;
				position: relative;
				top: -1px;
				border-radius: 3px;
				margin-left: 5px;
			}

			&.siteid {
				margin-top: 1px;
				font-size: 11px;
				color: var(--txt-lg);
				span {
					color: white;
					display: inline-block;
					margin-top: 3px;
					margin-left: 0;
				}
				&.search span {
					background: rgba(244, 128, 36, 0.35);
					padding: 0 3px;
				}
			}

			.salesforce-icon {
				display: inline-block;
				vertical-align: top;
				height: 4px;
				width: 4px;
				border-radius: 2px;
				margin-left: 6px;
				margin-top: 8px;
				background: var(--salesforce-blue);
				padding: 0;
				border: none;
			}

			.legacy {
				font-size: 13px;
				color: var(--teal);
				padding: 3px 0 1px 0;
			}
		}

		.user {
			color: var(--txt-lg);
			font-size: 11px;
			margin-top: 1px;
			font-weight: 500;
			span.green {
				color: var(--green);
			}
			span.yellow {
				color: var(--darkyellow);
			}
			span.orange {
				color: var(--orange);
			}
		}
	}

	& .search-field {
		background: var(--bg-d2);
		border: 1px solid transparent;
		outline: none;
		width: 100%;
		font-size: 13px;
		border-radius: 3px;
		text-align: center;
		color: white;
		&:focus {
			border: 1px solid var(--blue);
		}
	}

	& .company-column {
		.legacy-wrapper {
			margin: 25px 0 0 0;
		}
		.legacy-wrapper .title {
			color: var(--teal);
		}
	}

	/* Action bar (New CSD + help) */
	& .action-bar {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 1em;
		margin-bottom: 2.5em;
	}

	& .action-bar .add-btn {
		background: var(--pink);
		color: #fff;
		border: 2px solid var(--pink);
		font-size: 15px;
		font-weight: 700;
		letter-spacing: 0.3px;
		padding: 0.85em 2.25em;
		margin: 0;
		border-radius: 2em;
		box-shadow: 0 4px 14px rgba(255, 0, 140, 0.3);
		transition: transform 0.08s ease, box-shadow 0.12s ease, background 0.12s ease;
	}

	& .action-bar .add-btn:hover {
		background: #ff2da0;
		border-color: #ff2da0;
		box-shadow: 0 6px 20px rgba(255, 0, 140, 0.45);
		transform: translateY(-1px);
		cursor: pointer;
	}

	& .action-bar .add-btn:active {
		transform: translateY(0);
	}

	& .action-bar .help-btn {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		height: 42px;
		width: 42px;
		padding: 0;
		margin: 0;
		border-radius: 50%;
		color: var(--txt-lg);
		background: var(--bg-d0-dash);
		transition: color 0.12s ease, background 0.12s ease;
	}

	& .action-bar .help-btn:hover {
		color: var(--violet);
		background: var(--bg-dg);
		cursor: pointer;
	}

	/* Card styling for page content */
	& .company-content.card {
		display: flex;
		flex-wrap: wrap;
		align-items: flex-start;
		gap: 1.5em;
		text-align: left;
		background: var(--bg-d2);
		border: 1px solid var(--border-subtle);
		border-radius: 12px;
		padding: 1.5em;
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);
	}

	& .company-content.card .company-column {
		width: auto;
		flex: 1 1 320px;
		min-width: 0;
		padding: 0.5em;
		max-width: unset;
	}

	& .company-content.card .info-column {
		flex: 1 1 300px;
	}

	/* Neutralize nested Salesforce company-column so it fills the info column */
	& .company-content.card .info-column .company-column {
		display: block;
		width: 100%;
		max-width: unset;
		padding: 0;
	}

	/* Company info table */
	& .company-info-block {
		margin-bottom: 1.5em;
	}

	& .company-info-block h3,
	& .salesforce-wrapper > h3 {
		color: var(--txt-lg);
		text-align: center;
		font-size: 0.8em;
		text-transform: uppercase;
		letter-spacing: 1px;
		padding: 1em 0;
		margin: 0;
	}

	& .info-column .salesforce-wrapper {
		margin-top: 0.5em;
	}

	& .company-info-table {
		font-size: 0.8em;
		color: var(--txt-lg);
		width: 100%;
	}

	& .company-info-table > div {
		display: flex;
		gap: 10px;
		padding: 0.55em 0.25em;
		border-bottom: 1px solid var(--border-subtle);
	}

	& .company-info-table > div:last-child {
		border-bottom: none;
	}

	& .company-info-table dt {
		width: 38%;
		text-align: left;
		text-transform: uppercase;
		font-size: 0.92em;
		letter-spacing: 0.5px;
	}

	& .company-info-table dd {
		width: 62%;
		margin: 0;
		text-align: left;
		color: var(--txt-l);
		word-break: break-word;
	}

	& .company-info-table dd a {
		color: var(--salesforce-blue);
	}

	& .company-info-table dd.status-text {
		text-transform: capitalize;
		font-weight: 600;
	}

	& .company-info-table dd.status-text.active {
		color: var(--green);
	}

	& .company-info-table dd.status-text.paused {
		color: var(--red);
	}

	@media screen and (max-width: 1200px) {
		& .body-wrapper {
			padding: 6em 2em 6em 2em !important;
		}

		& .company-content.card {
			flex-direction: column;
		}

		& .company-column {
			width: 100%;
			max-width: unset;
			display: block;
			margin: 25px auto 0 auto;
		}

		& .body-wrapper.two-col .company-column {
			width: 100%;
			max-width: unset;
		}
	}
`;
